import {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom"

import {DashboardLayout} from "../../layouts/DashboardLayout"
import {ChatItem, listChatsApi} from "../../features/chat/api/chat.api"
import {CourseItem, listCoursesApi} from "../../features/courses/api/course.api"

import {TabButton} from "./components/TabButton"
import {DirectChatsList} from "./components/DirectChatsList"
import {CoursesList} from "./components/CoursesList"
import {ChatsInfoPanel} from "./components/ChatsInfoPanel";

type Tab = "direct" | "courses"

export const ChatsPage = () => {
    const [tab, setTab] = useState<Tab>("direct")
    const [loading, setLoading] = useState(true)

    const [chats, setChats] = useState<ChatItem[]>([])
    const [courses, setCourses] = useState<CourseItem[]>([])

    const userId = localStorage.getItem("user_id")

    useEffect(() => {
        const load = async () => {
            setLoading(true)
            try {
                if (tab === "direct") {
                    const res = await listChatsApi("direct")
                    setChats(res.data.items)
                } else {
                    const userId = localStorage.getItem("user_id")

                    if (userId) {
                        const res = await listCoursesApi(20, 0, userId)
                        setCourses(res.data.items)
                    }
                }
            } finally {
                setLoading(false)
            }
        }

        load()
    }, [tab])

    return (
        <DashboardLayout title="Чаты">
            <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit mb-6">
                <TabButton active={tab === "direct"} onClick={() => setTab("direct")}>
                    Личные
                </TabButton>
                <TabButton active={tab === "courses"} onClick={() => setTab("courses")}>
                    Курсы
                </TabButton>
            </div>

            {loading && <div className="p-6 text-gray-400">Загрузка…</div>}

            {!loading && (
    <div className="grid grid-cols-12 gap-6">
        {/* LEFT — список */}
        <div className="col-span-7">
            {tab === "direct" && (
                <DirectChatsList chats={chats}/>
            )}

            {tab === "courses" && (
                <CoursesList courses={courses}/>
            )}
        </div>

        {/* RIGHT — инфо панель */}
        <div className="col-span-5">
            <ChatsInfoPanel tab={tab}/>
        </div>
    </div>
)}

        </DashboardLayout>
    )
}